import Component from './analytics_total.vue'
export default Component
